if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.isBundle = this.dataset.bundleGifts === 'true';

        this.sectionId = this.dataset.sectionId;

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer');
        this.submitButton;
        this.quantityMin = this.dataset.min;
        this.partialAdd;
        this.quantitySelector = document.querySelector('.quantity__input');

        if (document.querySelector('cart-drawer') && window.run_cart_version == "sidecart") {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const formData = new FormData(this.form);
        const maxToAdd = Number(this.quantitySelector?.dataset?.max);
        const tryToAdd = Number(formData.get('quantity')) || 1;

        if (maxToAdd) {
          const cart = await fetch('/cart.js').then(r => r.json());

          const variantId = formData.get('id');
          const lineItem  = cart.items.find(item => item.id == variantId);
          const qtyInCart = lineItem ? lineItem.quantity : 0;

          if (qtyInCart + tryToAdd > maxToAdd) {
            this.handleErrorMessage(`Limit ${maxToAdd} per order.`);
            return;
          }
        }

        if(this.dataset.b2b && (formData.get('quantity') < this.quantityMin)) {
          let message = window.quickOrderListStrings.min_error.replace(
            '[min]',
            this.quantityMin
          );
          this.handleErrorMessage(message);
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        if (this.querySelector('.adding_to_cart')) {
          this.querySelector('.adding_to_cart').classList.remove('hidden');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        if (this.cart && window.run_cart_version == "sidecart") {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        } else {
          formData.append('sections', 'cart-icon-bubble');
          formData.append('sections_url', window.location.pathname);
        }

        let productId = formData.get('id');

        if (this.isBundle) {
          let product_data = JSON.parse(this.dataset.bundle);

          product_data.forEach((item, index) => {
            if (item.id == productId) {
              formData.append(
                `properties[_bundleSize]`,
                item.properties._bundleSize
              );
              formData.append(
                `properties[_bundleGift]`,
                item.properties._bundleGift
              );
              formData.append(`properties[_gui]`, item.properties._gui);
            } else {
              formData.append(`items[${index}][id]`, item.id);
              formData.append(`items[${index}][quantity]`, item.quantity);
              formData.append(
                `items[${index}]properties[_gui]`,
                item.properties._gui
              );
              formData.append(
                `items[${index}]properties[_bundleSize]`,
                item.properties._bundleSize
              );
              if (item.properties._bundleGift) {
                formData.append(
                  `items[${index}]properties[_bundleGift]`,
                  item.properties._bundleGift
                );
              }
            }
          });
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (this.sectionId == 'Quickview') {
              document.querySelector('#PopupModal-Quickview').hide();
            }

            const match = response.description?.match(
              /^Only (\d+) items? were added to your cart due to availability\.$/
            );
            this.partialAdd = response.status === 422 && match;

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.error = true;
              if(!this.partialAdd) return;
            }

            this.error = false;

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }

            if (this.cart && window.run_cart_version == "sidecart") {
              this.cart.renderContents(response);
            } else {
              fetch('/cart.js')
              .then(r => r.json())
              .then(async (cart) => {
                
                if(applyOfferCode) {
                  try {
                    cart = await ensurePromoCode(cart, applyOfferCode);
                    const response = await fetch(`${window.Shopify.routes.root}cart`);
                  } catch (error) {
                    console.error(`${applyOfferCode} could not be applied:`, error);
                  }
                }
                
                document.querySelectorAll('.cart-count-bubble').forEach(bubble => {
                  bubble.textContent = cart.item_count;
                });

                const variantId = formData.get('id');
                const productPercentOff = formData.get('product-percent-off');
                const lineItem = cart.items.find(
                  item => item.id == variantId
                );
                const qtyInCart = lineItem ? lineItem.quantity : 0;
                if (this.quantitySelector) {
                  this.quantitySelector.dataset.cartQuantity = qtyInCart;
                }

                if (!isNaN(productPercentOff) && productPercentOff !== '') {
                  await setSaleAttribute(variantId, Number(productPercentOff));
                }

              });

              const cartBubbleHeader = document.querySelector('#cart-icon-bubble');
              cartBubbleHeader.classList.add('pulsate');

              setTimeout(() => {
                cartBubbleHeader.classList.remove('pulsate');
              }, 4000);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty');
            
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.adding_to_cart').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variants.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      get submitButton() {
        return this.querySelector('button[name="add"], [type="submit"]');
      }

    }
  );
}

if (!customElements.get('bundle-select')) {
  customElements.define(
    'bundle-select',
    class BundleSelect extends HTMLElement {
      constructor() {
        super();

        this.sku = this.querySelector('.bundle__sku');
        this.name = this.querySelector('.bundle__name');

        this.dropdown = this.querySelector('.product__bundle-product-select');

        if (this.dropdown) {
          this.dropdown.addEventListener(
            'change',
            this.onChangeHandler.bind(this)
          );
        }
      }

      onChangeHandler(evt) {
        this.sku.value = evt.target.value;
        this.name.value = evt.target.selectedOptions[0].dataset.name;
      }
    }
  );
}

if (!customElements.get('klaviyo-oos')) {
  customElements.define(
    'klaviyo-oos',
    class KlaviyoOOS extends HTMLElement {
      constructor() {
        super();

        this.trigger = document.querySelector('.klaviyo-bis-trigger');
        this.button = this.querySelector('[type="submit"]');

        if (this.button) {
          this.button.addEventListener('click', this.onClickHandler.bind(this));
        }
      }

      onClickHandler(e) {
        e.preventDefault();

        const email = this.querySelector('input[name="email"]').value;
        if (!email) {
          console.error('Email is required for back-in-stock subscription.');
          return;
        }

        const payload = {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                  },
                },
              },
              channels: ['EMAIL'],
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${this.dataset.variantId}`,
                },
              },
            },
          },
        };

        var requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2024-06-15',
          },
          body: JSON.stringify(payload),
        };

        fetch(
          'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=X8dvUz',
          requestOptions
        )
          .then((result) => {
            const menuDrawer = this.closest('menu-drawer');
            menuDrawer.closeMenuDrawer(this.trigger);
          })
          .catch((error) => console.log('error', error));
      }
    }
  );
}

async function setSaleAttribute(variantId, salePercentage) {
  try {
    const cart = await fetch('/cart.js').then((response) => {
      if (!response.ok) {
        throw new Error('Could not retrieve cart');
      }

      return response.json();
    });

    const attributes = {};

    // Get the variant IDs currently present in the cart.
    const activeVariantIds = new Set(
      cart.items.map((item) => String(item.variant_id))
    );

    // Remove stale sale attributes for variants no longer in the cart.
    Object.keys(cart.attributes || {}).forEach((key) => {
      if (!key.startsWith('sale_')) {
        return;
      }

      const attributeVariantId = key.replace('sale_', '');

      if (!activeVariantIds.has(attributeVariantId)) {
        attributes[key] = null;
      }
    });

    // Add or update the sale attribute for the current item.
    attributes[`sale_${variantId}`] = String(salePercentage);

    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({attributes}),
    });

    if (!response.ok) {
      throw new Error('Could not update sale attributes');
    }

    return response.json();
  } catch (error) {
    console.warn('Could not sync sale cart attribute:', error);
    return null;
  }
}

async function ensurePromoCode(cart, promoCode) {
  const hasPromoCode = cart.discount_codes?.some(
    discount =>
      discount.code.toUpperCase() === promoCode.toUpperCase()
  );

  if (hasPromoCode) {
    if (applyGiftProduct) {
      cart = await ensureMysteryGifts(cart, applyGiftProduct);
    }

    return cart;
  }

  const response = await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      discount: promoCode,
    }),
  });

  if (!response.ok) {
    throw new Error(`Unable to apply promo code "${promoCode}"`);
  }

  cart = await response.json();

  console.log('offer set');

  if (applyGiftProduct) {
    cart = await ensureMysteryGifts(cart, applyGiftProduct);
  }

  return cart;
}

async function ensureMysteryGifts(cart, applyGift) {
  const hasMysteryGift = cart.items?.some(
    item => item.properties?._mystery_gift === 'true'
  );

  if (hasMysteryGift) {
    console.log('mystery gift present');
    return cart;
  }

  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: Number(applyGift),
      quantity: 1,
      properties: {
        _mystery_gift: 'true',
        _gift_promo: applyOfferCode
      }
    })
  });

  if (!response.ok) {
    throw new Error('Unable to add mystery gifts');
  }

  console.log('mystery gift added');

  return fetch('/cart.js').then(response => response.json());
}